import * as firebase from "firebase/app";
import "firebase/storage";
import "lib/firebase-provider/firebaseApp";

// export async function storageFetch(url) {
//   // if (process.env.NODE_ENV === "development" && process.env.REACT_APP_USE_LOCAL_DATA) {
//   //   try {
//   //     const response = await fetch(url);
//   //     const json = await response.json();

//   //     return json;
//   //   } catch (err) {
//   //     console.error(`Error fetching ${url}`, err);
//   //     throw err;
//   //   }
//   // } else {
//   try {
//     const downloadUrl = await firebase.storage().ref(url).getDownloadURL();
//     const response = await fetch(downloadUrl);
//     const json = await response.json();

//     return json;
//   } catch (err) {
//     console.error(err);
//     throw err;
//   }
//   // }
// }

export async function jsonFetch(url) {
  try {
    const response = await fetch(url, {
      headers: { accept: "application/json" },
    });

    if (!response.ok) {
      throw new Error(response.err);
    }
    const json = await response.json();

    return json;
  } catch (err) {
    console.error(`Error fetching ${url}`, err);
    throw err;
  }
}
